import { DASHBOARD_SESSION_ID, DASHBOARD_SESSION_START_TIMESTAMP } from "./Constant";

export function getShellSessionFromStorage() {
  return {
    sessionId: sessionStorage.getItem(DASHBOARD_SESSION_ID),
    sessionStartTimestamp: sessionStorage.getItem(DASHBOARD_SESSION_START_TIMESTAMP),
  };
}
